export const PATH_ROOT = '/';
export const PATH_ERROR = 'error';
export const PATH_LOADING = 'loading';
export const PATH_INTRO = 'intro';
export const PATH_NO_CAMERA = 'nocamera';
export const PATH_NO_PERMISSION = 'nopermission';
export const PATH_NO_TIME_LEFT = 'notimeleft';
export const PATH_WAITING = 'waiting';
export const PATH_LIVENESS = 'liveness';
export const PATH_SUCCESS = 'success';
export const PATH_TRY_AGAIN = 'tryagain';
export const PATH_LINKED = 'linked';
